// Priority levels and their theme colours. A complaint's priority is derived
// from the nature of complaint it is filed under (configured by Admin/CRO Lead),
// so this is the single place that maps a priority to its colour/badge styling.

export const PRIORITIES = ['Critical', 'High', 'Medium', 'Low'];

export const PRIORITY_META = {
  Critical: { color: '#dc2626', bg: '#fef2f2', border: '#fecaca', icon: 'mdi:fire' },
  High: { color: '#d97706', bg: '#fffbeb', border: '#fde68a', icon: 'mdi:alert' },
  Medium: { color: '#16a34a', bg: '#f0fdf4', border: '#bbf7d0', icon: 'mdi:alert-circle-outline' },
  Low: { color: '#2563eb', bg: '#eff6ff', border: '#bfdbfe', icon: 'mdi:information-outline' },
};

export const priorityMeta = (p) => PRIORITY_META[p] || { color: '#64748b', bg: '#f1f5f9', border: '#e2e8f0', icon: 'mdi:help-circle-outline' };
